import React from "react";
import LoadingScreen from "../../../utils/LoadingScreen";
import { formatDate } from "../../../utils/dateFormatter";
import { ToastContainer } from "react-toastify";

const ProcessedSettlementsTable = ({ data = [], loading }) => {

  return (
    <>
    <ToastContainer/>
      {/* <div className="p-3 font-semibold border-b relative montserrat-font-1">Processed Settlements</div> */}

      <table className="w-full text-sm montserrat-font-1">
        <thead className="bg-green-200 montserrat-font-1">
          <tr>
            <th className="p-3">S.No.</th>
            <th className="p-3">ID</th>
            <th className="p-3">Invoice No</th>
            <th className="p-3">Invoice Name</th>
            <th className="p-3">From</th>
            <th className="p-3">To</th>
            <th className="p-3">Download</th>
          </tr>
        </thead>

        <tbody>
  {loading ? (
    <tr>
      <td colSpan="7" className="text-center py-10">
        <LoadingScreen text="Loading data..." />
      </td>
    </tr>
  ) : data.length === 0 ? (
    <tr>
      <td colSpan="10" className="text-center py-6 text-gray-500">
        No Records Found
      </td>
    </tr>
  ) : (
            data.map((item, i) => (
              <tr key={i} className="border-b text-center">
                <td className="p-2">{i + 1}</td>

                <td className="p-2">{item.id}</td>

                <td className="p-2 font-semibold">
                  {item.invoice_number || "NA"}
                </td>

                <td className="p-2">{item.invoice_name || "NA"}</td>

               <td className="p-2">{formatDate(item.from_date)}</td>

<td className="p-2">{formatDate(item.to_date)}</td>

                <td className="p-2">
                  {item.invoice_url ? (
                    <button
                      className="text-blue-600 underline"
                      onClick={() => window.open(item.invoice_url, "_blank")}
                    >
                      Download Invoice
                    </button>
                  ) : (
                    <span className="text-gray-400">Not Available</span>
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </>
  );
};

export default ProcessedSettlementsTable;
